import { Size, Tooltip } from '@sgme/ui';
import classNames from 'classnames';
import classnames from 'classnames';
import type { ProductSelectorTabType } from 'components/shared/ProductAndClientSelector/productAndClientSelector.model';
import type { ProductVariation } from 'models/productsReferential';
import { MouseEvent } from 'react';
import { useIntl } from 'react-intl';
import { usePinnedProducts } from 'routes/essential-workspace/components/product-selector/hooks/use-pinned';
import type { WorkspaceWithProductSelector } from 'state/workspaces/workspaces/workspaces.model';

export interface ProductPinnedButtonProps {
  className?: string;
  size?: Size;
  productVariation: ProductVariation;

  workspace: WorkspaceWithProductSelector;
  tabType: ProductSelectorTabType;
  iconName?: string;
}

export function ProductPinnedButton({
  productVariation,
  className,
  workspace,
  tabType,
  size = 'md',
  iconName = 'push_pin',
}: ProductPinnedButtonProps) {
  const { formatMessage } = useIntl();
  const { isProductPinned, handlePinToggle } = usePinnedProducts(workspace);

  const isPinned = isProductPinned(productVariation);

  const pinProduct = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    handlePinToggle({ productVariation, tabType });
  };

  const tooltipMessage = formatMessage({
    id: isPinned ? 'productSelector.tooltips.unpin' : 'productSelector.tooltips.pin',
  });

  return (
    <Tooltip position="right" contents={tooltipMessage}>
      <button
        tabIndex={-1}
        className={classNames(`btn btn-${size} btn-icon btn-flat-secondary`, { 'btn-flat-info': isPinned })}
        onClick={pinProduct}
      >
        <em className={classnames('icon', { 'icon-outlined': !isPinned }, className)}>{iconName}</em>
      </button>
    </Tooltip>
  );
}
